import { render, staticRenderFns } from "./CombinationPrice.vue?vue&type=template&id=30076062&scoped=true&lang=pug"
import script from "./CombinationPrice.vue?vue&type=script&lang=js"
export * from "./CombinationPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30076062",
  null
  
)

export default component.exports